import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_ACCESS_TOKEN, COMMON_SSO_MOBILE } from "../constants/sso";
import { decrypt, decryptLocalStorageMobileNo, generateSalt } from "@repo/shared-utils/crypto";
import { UserSessionDataTypes, getCookie, getSessionData } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IStampData {
  mobileNo: string;
  firstNameNameTrue?: string;
  lastName?: string;
  utmSourceUtmTrue?: string;
  utmMediumUtmTrue?: string;
  utmCampaignUtmTrue?: string;
  utmKeywordUtmTrue?: string;
  deviceTrue?: string;
  cookieId?: string;
  clientId?: string;
  lastClickedClickTrue?: string;
  formNameForm?: string;
  formId?: string;
  otpSource?: string;
  pageNameForm?: string;
  utmContentUtmTrue?: string;
  pageUrlTrue?: string;
  uniqueCode?: string;
  offerId?: string;
  offers?: string;
  amount?: string;
  product?: string;
  productOfferingType?: string;
  interestOffers?: string;
  customerName?: string;
  dateOfBirthDateTrue?: string;
  emailId?: string;
  addressLine1AddressTrue?: string;
  addressLine2AddressTrue?: string;
  addressLine3AddressTrue?: string;
  stateDropdownTrue?: string;
  cityDropdownTrue?: string;
  pincodePincodeTrue?: string;
  fullNameFullNameTrue?: string;
  genderRadioTrue?: string;
  typeOfOccupationDropdownTrue?: string;
  lineStatus?: string;
  createdipTrue?: string;
  panCardPanCardTrue?: string;
  personalEmailIdEmailIdTrue?: string;
  maximumLoanAvailedNumberTrue?: string;
  customerRefno?: string;
  insuranceProductInterestedDropdownFalse?: string;
  tenureOptionDropdownTrue?: string;
  isDownPaymentDoneRadioTrue?: string;
  isPropertyIdentifiedforPurchaseDropdownTrue?: string;
  parentNameform?: string;
  tenureOptionMonthDropdownTrue?: string;
  availEmiDropdownTrue?: string;
  howManyMonthTextFalse?: string;
  totalMonthlyEmiNumberTrue?: string;
  dealerID?: string;
  accountNumber?: string;
  urnNumber?: string;
  dateOfRegDateTrue?: string;
  loanAmountRequiredAmountTrue?: string;
  membershipNumberNumberTrue?: string;
  enquiryDate?: string;
  referID?: string;
  amountOffer?: string;
  offerAmount?: string;
  offerStatus?: string;
  productNameTrue?: string;
  makeaWishDropdownTrue?: string;
  passoutYearDropdownTrue?: string;
  cidValueCidValueTrue?: string;
  ownerNumber?: string;
  edwType?: string;
  fullName?: string;
  city?: string;
  membershipNumber?: string;
  formName?: string;
  personalEmailId?: string;
  gstNoAlphanumericTrue?: string;
  stateStateTextTrue?: string;
  typeOfBusinessRadioTrue?: string;
  wcmtime?: string;
  createOn?: string;
  organisationAlphanumericOrgTrue?: string;
  categoryDropdownTrue?: string;
  annualBusinessTurnover?: string;
  descriptionTextareaFalse?: string;
  companyNameTextNumSpecialTrue?: string;
  productDropdownTrue?: string;
  typeOfProductDropdownTrue?: string;
  businessVintage?: string;
  propertyValue?: string;
  functionIndustry?: string;
  feedbackResponse?: string;
  no_of_family_member_dropdownTrue?: string;
  education_degree_dropdownTrue?: string;
  other?: string;
  years_of_exp_dropdownTrue?: string;
  companyname_textTrue?: string;
  industry_type_textFalse?: string;
  businessName?: string;
  makeWishProduct?: string;
  rating?: string;
  Relationship_with_Nominee_dropdownTrue?: string;
  comment?: string;
  consentStatus?: boolean | string;
  brand?: string;
  businessCategory?: string;
  custSegment?: string;
  referralProfession?: string;
  device?: string;
  What_do_you_wish_dropdownTrue?: string;
  specialization?: string;
  insuranceProductCode?: string;
  isBalic?: string;
  _csrf?: string;
}

export const getUserDetailsAndToken = (): string[] => {
  const userDetails = getCookie("userDetails") || "";
  const JWTToken = localStorage.getItem(COMMON_SSO_ACCESS_TOKEN) || "";
  return [userDetails, JWTToken];
};
export const getUserdata = async (userData: string): Promise<[UserSessionDataTypes, string]> => {
  const salt: string = await generateSalt();
  const userInformation = userData ? JSON.parse(userData) : {};
  const phoneNumber = (await decrypt(userInformation?.mobileNo ?? "9999999999", salt)) as string;
  return [userInformation, phoneNumber];
};
export const TodaysDate = (dIn?: Date): string => {
  const d = dIn ? new Date(dIn) : new Date();
  let day = d.getDate().toString();
  let month = (d.getMonth() + 1).toString();
  const year = d.getFullYear();
  month = month.length < 2 ? `0${month}` : month;
  day = day.length < 2 ? `0${day}` : day;
  return [year, month, day].join("-");
};
export const GetSessionItem = (itemKey: string): unknown => {
  const itemValue = sessionStorage.getItem(itemKey);
  return itemValue;
};
export const CaptureInterestStampData = async (stampingData?: IStampData) => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const { dealerId, custType } = await getSessionData();
  const stampingInfo: IStampData = {
    mobileNo: mobileNo || "",
    formId: "QRCode_Web",
    clientId: getCookie("_ga") || "NA",
    dealerID: stampingData?.dealerID ? stampingData.dealerID : dealerId || "",
    lastClickedClickTrue: getCookie("LastClickCookie") || "NA",
    deviceTrue: getCookie("tvc_device_details") || "NA",
    dateOfRegDateTrue: TodaysDate(),
    customerRefno: custType || "",
    lineStatus: (GetSessionItem("lineStatus") as string) || "",
    pageUrlTrue: document.URL,
    pageNameForm: stampingData?.pageNameForm,
    utmSourceUtmTrue: getCookie("utm_source") || "PMGQR",
    utmMediumUtmTrue: getCookie("utm_medium") || "PMGQR",
    offerStatus: (GetSessionItem("offerStatus") as string) || "",
    makeaWishDropdownTrue: stampingData?.makeaWishDropdownTrue,
    interestOffers: stampingData?.makeaWishDropdownTrue ? stampingData?.interestOffers : "NA",
    fullName: stampingData?.fullName,
    consentStatus: stampingData?.consentStatus,
  };
  stampApi(stampingInfo);
};

export const stampApi = async (stampingInfo: IStampData): Promise<IResponse<null>> => {
  try {
    const response = await encryptedRequest<null>({
      method: "POST",
      url: API_PATHS.stamping,
      data: stampingInfo,
    });

    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
